import { h3, h4, h5 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import LandingImage from '../LandingImage';

import { TitleSize } from './types';

export const ImageWrapper = styled.div<{
  height: string;
  backgroundColor?: string;
  aspectRatio?: number;
  showOverlayOnHover?: boolean;
}>`
  height: ${({ height }) => height};
  position: relative;
  border: 1px solid ${themeStyle.varInkLight};
  border-radius: 20px;
  overflow: hidden;
  background-color: ${({ backgroundColor }) => backgroundColor};
  aspect-ratio: ${({ aspectRatio }) => aspectRatio ?? 'initial'};

  ${({ showOverlayOnHover }) =>
    showOverlayOnHover &&
    `
    &:hover::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.15);
      z-index: 1;
    }
  `}
`;

export const Image = styled(LandingImage).withConfig({
  shouldForwardProp: () => true,
})`
  border-radius: 5px;
  background-color: transparent;
  object-fit: cover;
`;

export const Title = styled.div<{ $size?: TitleSize }>`
  ${({ $size }) => ($size === 'h3' ? h3 : $size === 'h4' ? h4 : h5)}
`;

export const ButtonEdit = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  width: 32px;
  height: 32px;
  border: 1px solid ${themeStyle.varInkSuperLight};
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
  background-color: ${themeStyle.varBackgroundAlt};
  border-radius: 50%;
`;

export const ButtonHover = styled.button`
  cursor: pointer;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  width: calc(100% - 16px);
  height: 40px;
  padding: 0 8px;
  pointer-events: none;
  transition: opacity ease-in-out ${themeStyle.transitionDuration};

  border: none;
  border-radius: ${themeStyle.radiusMedium};
  background-color: ${themeStyle.varInkLight};
  z-index: 2;

  ${ImageWrapper}:hover & {
    visibility: visible;
    opacity: 1;
    pointer-events: all;
  }
`;

export const TextBlockWrapper = styled.div`
  p {
    line-height: 25.6px;
  }
`;
